/**
 * @fileoverview POST handler for the "/app_settings/tag_delete" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsTagDeleteCacheKeys } from "./constants";
import type { PostAppSettingsTagDeleteProps, AppSettingsTagDeleteResult } from "./types";

export const deleteAppSettingsTag = reactQueryMutationAdapter(
  appSettingsTagDeleteCacheKeys,
  (props: PostAppSettingsTagDeleteProps): Promise<AppSettingsTagDeleteResult> => {
    return fetch("/app_settings/tag_delete", "POST", props);
  }
);
